<template>
    <div  class="el-menu-demo">
        <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        :ellipsis="false"
        @select="handleSelect"
        router
        >
        <el-menu-item index="0">
            <img style="width: 85%;height: 85%;" src="../../../public/img/icons/logo290x80.png"
            alt="Element logo" />
        </el-menu-item>
        <el-menu-item index="/" class="menuitem">首页</el-menu-item>
        <el-sub-menu index="2" >
            <template #title>  <span class="menuitem">走进新光</span></template>
            <el-menu-item index="/A111">关于我们</el-menu-item>
            <el-menu-item index="/A112">企业文化</el-menu-item>
            <el-menu-item index="/A113">新光风采</el-menu-item>
        </el-sub-menu>
        <el-menu-item index="/A121" class="menuitem">新闻动态</el-menu-item>
        <el-menu-item  class="menuitem"><span @click="open_b">在线商城</span></el-menu-item>
        <el-sub-menu index="4" >
            <template #title>  <span class="menuitem">商务服务</span> </template>
            <el-menu-item ><span @click="open_n">流向查询（新）</span></el-menu-item>
            <el-menu-item ><span @click="open_o">流向查询（旧）</span></el-menu-item>
            <el-menu-item ><span @click="open_z">质检单下载</span></el-menu-item>
            <el-menu-item ><span @click="open_k">自主下单</span></el-menu-item>
        </el-sub-menu>
        <el-menu-item index="/A151" class="menuitem">联系我们</el-menu-item>

    </el-menu>
    </div>
    
</template>

<script>
    export default {
        methods: { 
            open_n(){
                window.open('http://122.228.54.130:37452', '_blank')
            },
            open_o(){
                window.open('http://122.228.54.130:37451/Account/Login?type=1', '_blank')
            },
            open_z(){
                window.open('http://122.228.54.130:37451/Rpt/ZhJRpt', '_blank')
            },
            open_k(){
                window.open('http://122.228.54.130:37855', '_blank')
            },
            open_b(){
                window.open('http://122.228.54.130:47601', '_blank')
            },
        }
    }
</script>

<style scoped>
.el-menu-demo{width: 1200px;  margin: 0 auto;}
.lef{float: left;
    width: 1200px;
    margin: 0 auto;}
.el-menu{height: 80px;}
.el-menu--horizontal > .el-menu-item:nth-child(1) {
    margin-right: auto;
}
.menuitem{font-size: 16px;}

</style>